module.exports = __webpack_public_path__ + "static/media/living_room.8abd62fb.png";